import { createContext, useContext } from 'react';
export { Trans } from '@wix/wix-i18n-config';

// Workaround for https://github.com/isaachinman/next-i18next/issues/1781

export const TranslationContext = /*#__PURE__*/createContext(undefined);
export function useTranslation() {
  const context = useContext(TranslationContext);
  if (context === undefined) {
    throw new Error('useTranslation must be used within a TranslationProvider');
  }
  return context;
}
//# sourceMappingURL=translation-context.js.map